import { AxiosResponse } from 'axios';
import api from '../../utils/api';
import { SelectItem, User } from '~/types';
import { BusinessInformation } from '~/types/businesseInformation';

type Comissionado = {
  nome: string;
  codigo_sap: string;
};

type Grupoeconomico = {
  id_grupoeconomico: string;
  nm_grupoeconomico: string;
};

export async function getBussinessInformation(
  dt_faturamento_inicio?: string,
  dt_faturamento_fim?: string,
  ids_grupo_economico?: string,
  codigos_sap?: string,
  st_pagamento?: string,
): Promise<BusinessInformation[]> {
  const { data } = await api.get(`/comissionado`, {
    params: {
      ...(dt_faturamento_inicio && { dt_faturamento_inicio }),
      ...(dt_faturamento_fim && { dt_faturamento_fim }),
      ...(ids_grupo_economico && { ids_grupo_economico }),
      ...(codigos_sap && { codigos_sap }),
      ...(st_pagamento && { st_pagamento }),
    },
  });

  return data;
}

export async function getComissionadoAsSelect(
  ids_grupo_economico?: string,
): Promise<SelectItem[]> {
  const { data } = await api.get<Comissionado[]>('comissionado/comissionados', {
    params: {
      ...(ids_grupo_economico && { ids_grupo_economico }),
    },
  });

  return data.map(comissionad => ({
    value: String(comissionad.codigo_sap),
    label: comissionad.nome,
  }));
}

export async function getGrupoeconomicoAsSelect(): Promise<SelectItem[]> {
  const { data } = await api.get<Grupoeconomico[]>(
    'comissionado/grupo_economico',
  );

  return data.map(grupo => ({
    value: String(grupo.id_grupoeconomico),
    label: grupo.nm_grupoeconomico,
  }));
}

export async function getXlsxComissionado(
  dt_faturamento_inicio?: string,
  dt_faturamento_fim?: string,
  ids_grupo_economico?: string,
  codigos_sap?: string,
  st_pagamento?: string,
): Promise<AxiosResponse<any>> {
  const url = 'comissionado/xlsx';
  return api.get(url, {
    params: {
      ...(dt_faturamento_inicio && { dt_faturamento_inicio }),
      ...(dt_faturamento_fim && { dt_faturamento_fim }),
      ...(ids_grupo_economico && { ids_grupo_economico }),
      ...(codigos_sap && { codigos_sap }),
      ...(st_pagamento && { st_pagamento }),
    },
    headers: {
      'Content-Type': 'application/xlsx',
    },
    responseType: 'blob' as 'json',
  });
}
